import * as React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import notify from '../../../shared/feedback/notifications';
import { connect } from 'react-redux';
import { parse } from 'query-string';
import * as Features from '../../../shared/Features';
import { phoneRegexp, emailRegexp } from '../../../shared/ValidationRegexp';
import { Translate } from '../../../shared/LanguageService';
import { handleError } from '../../../shared/ErrorCatching';
import {
    ICreateOrder,
    ICreateOrderAddress,
    ICreateOrderContact,
    ICreateOrderOther,
    IEnumeration,
    IBrokerAgent,
    IBrokerFirm
} from '../Entities';
import { assign } from '../../../shared/Assign';
import FormInputChangeHandler from '../../../shared/form/FormInputChangeHandler';
import ScandphotosPhotographerBooking from '../../photographerBooking/scandphotos/ScandphotosPhotographerBooking';
import ICalendarItem from '../../calendar/Types';
import ICoordinate from '../../map/ICoordinate';
import { getUser } from '../../../reducers/userReducer';
import ScandphotosCreateOrderConfirmationPage from './subviews/ScandphotosCreateOrderConfirmationPage';
import ScandphotosCreateOrderCompletePage from './subviews/ScandphotosCreateOrderCompletePage';
import ScandphotosCreateOrderProductsPage from './subviews/ScandphotosCreateOrderProductPage';
import ScandphotosCreateOrderBrokerAndFirmPage from './subviews/ScandphotosCreateOrderBrokerAndFirmPage';
import ScandphotosCreateOrderContactPage from './subviews/ScandphotosCreateOrderContactPage';
import * as actions from './actions/ScandphotosOrdersActions';
import * as InitialState from './reducers/ScandphotosInitialState';
import * as Actions from './actions/ScandphotosOrdersActions';
import * as Api from './ScandphotosOrdersApi';
import { getOrderProperties, getNewProducts } from './reducers/ScandphotosCreateOrderReducer';
import PendingOrderStore, { IPendingOrder } from '../../../shared/PendingOrderStore';
import PickupOrderDialog from '../PickupOrderDialog';
import { getContentProviderNameFromId } from '../../../shared/ContentProvider';
import { order } from '../view/imageprocessing/list/__tests__/helpers';

interface IActions {
    newOrder: (
        pendingOrderId?: string,
        orderCollectionId?: number,
        newPendingOrder?: boolean
    ) => any;
    getFirmDetails: (firmId: number) => any;
}

interface IProps {
    actions: IActions;
    orderProperties: ICreateOrder;
    newProducts: any;
    user: any;
    history: any;
    params: any;
    location: any;
    match: any;
}

interface IState {
    products: any[];
    addressInfo: ICreateOrderAddress;
    contactInfo: ICreateOrderContact;
    otherInfo: ICreateOrderOther;
    objectTypes: IEnumeration[];
    errors: any;
    activePage: number;
    selectedProduct: number;
    selectedAdditionalProducts: number[];
    selectedOrderAdditions: number[];
    calendarItem: ICalendarItem;
    nrOfPlans: number;
    objectTypeLockDown: number;
    selectedBrokerAgent: IBrokerAgent;
    selectedBrokerFirm: IBrokerFirm;
    isAddressValid: boolean;
    orderCollectionId: number;
    pendingOrderId: string;
    brokerFirmId: number;
    phoneToValidate: string;
    pickupDialogOpen: boolean;
    keepPendingOrderLoading: boolean;
}

class ScandphotosCreateOrderPage extends React.Component<IProps, IState> {
    formInputChangeHandler: FormInputChangeHandler;

    constructor(props: any) {
        super(props);

        this.state = {
            products: [],
            addressInfo: {} as ICreateOrderAddress,
            contactInfo: {} as ICreateOrderContact,
            otherInfo: {} as ICreateOrderOther,
            objectTypes: [],
            errors: {},
            activePage: 0,
            selectedProduct: null,
            selectedAdditionalProducts: [],
            selectedOrderAdditions: [],
            calendarItem: {} as ICalendarItem,
            nrOfPlans: 0,
            objectTypeLockDown: null,
            selectedBrokerAgent: null,
            selectedBrokerFirm: null,
            isAddressValid: false,
            orderCollectionId: this.props.match.params.orderCollectionId,
            pendingOrderId: null,
            brokerFirmId: 0,
            phoneToValidate: null,
            pickupDialogOpen: false,
            keepPendingOrderLoading: false
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps: IProps) {
        if (nextProps.newProducts && nextProps.newProducts !== this.props.newProducts) {
            this.setState({ products: nextProps.newProducts } as IState);
        } else if (
            nextProps.orderProperties &&
            nextProps.orderProperties !== this.props.orderProperties
        ) {
            let activePage = Features.hasFeature(Features.AssistCreateOrder, this.props.user)
                ? 0
                : Features.hasFeature(Features.CreateOwnOrder, this.props.user) &&
                  nextProps.orderProperties.availableBrokerAgents.length > 0 &&
                  nextProps.orderProperties.availableBrokerAgents[0].availableBrokerFirms.length ===
                      1
                ? 1
                : 0;

            let initialState = assign({}, InitialState.default.orderProperties);

            let products = [...nextProps.orderProperties.products];

            if (nextProps.orderProperties.existingPlanOrderId) {
                products = products.filter((x) => x.productTypeType !== 1);
            }

            if (nextProps.orderProperties.pendingOrderId) {
                PendingOrderStore.save({
                    pendingOrderId: nextProps.orderProperties.pendingOrderId,
                    address: nextProps.orderProperties.address.addressLine1,
                    contentProviderId: nextProps.orderProperties.contentProviderId,
                    orderCollectionId: this.state.orderCollectionId
                });
            }

            this.setState({
                products: products,
                addressInfo: nextProps.orderProperties.address || initialState.addressInfo,
                contactInfo: nextProps.orderProperties.contact || initialState.contactInfo,
                otherInfo: nextProps.orderProperties.other || initialState.orderOtherInfo,
                objectTypes: nextProps.orderProperties.objectTypes || [],
                activePage: activePage,
                selectedProduct: nextProps.orderProperties.productInfo
                    ? nextProps.orderProperties.productInfo.selectedProduct || null
                    : null,
                selectedAdditionalProducts: nextProps.orderProperties.productInfo
                    ? nextProps.orderProperties.productInfo.selectedAdditionalProducts || []
                    : [],
                selectedOrderAdditions: nextProps.orderProperties.productInfo
                    ? [...nextProps.orderProperties.productInfo.selectedOrderAdditions] || []
                    : []
            } as IState);
        }
    }

    async componentDidMount() {
        const { orderCollectionId } = this.state;
        const { actions, location } = this.props;

        const params = parse(location.search);
        const { pendingOrderId, newPendingOrder } = params;

        let pickupDialogOpen = false;
        let pendingOrder = PendingOrderStore.get();

        if (pendingOrder && !pendingOrderId) {
            pickupDialogOpen = true;
        }

        try {
            await actions.newOrder(pendingOrderId, orderCollectionId, newPendingOrder);
            this.preSelectBrokerAgent();
        } catch (error) {
            handleError(error);
        }

        this.setState({ pendingOrderId, pickupDialogOpen } as IState);
    }

    preSelectBrokerAgent = () => {
        if (this.props.orderProperties.availableBrokerAgents) {
            this.onAgentSelected(this.props.user.details.id);
        }
    };

    onPackageChange = (id: number) => {
        let products = this.state.products;
        let selectedProduct = null;
        let objectTypeLockDown = null;
        for (let product of products) {
            if (product.id === id) {
                selectedProduct = product.id;
                objectTypeLockDown = product.lockObjectTypeTo;
            }
        }

        this.setState({
            products: products,
            selectedProduct: selectedProduct,
            objectTypeLockDown: objectTypeLockDown
        } as IState);

        if (objectTypeLockDown) {
            let addressInfo = assign({}, this.state.addressInfo);
            addressInfo.objectType = objectTypeLockDown.value;
            this.setState({
                addressInfo: addressInfo
            } as IState);
        }
    };

    onPackageAdditionChange(id: number) {
        let selectedAdditionalProducts = [...this.state.selectedAdditionalProducts];
        let index = selectedAdditionalProducts.indexOf(id);
        if (index >= 0) {
            selectedAdditionalProducts.splice(index, 1);
        } else {
            selectedAdditionalProducts.push(id);
        }

        this.setState({
            selectedAdditionalProducts: selectedAdditionalProducts
        } as IState);
    }

    onNrOfPlansChange = (evt: any) => {
        let value = evt.target.value;
        this.setState({
            nrOfPlans: value
        } as IState);
    };

    onOrderInfoChange = (collection: string, key: string, evt: any, rawValue?: string) => {
        let state = assign({}, this.state) as IState;
        let value = evt !== null && typeof evt === 'object' && evt.target ? evt.target.value : evt;
        if (!state.hasOwnProperty(collection) || !state[collection].hasOwnProperty(key)) {
            return;
        }

        if (
            collection == 'contactInfo' &&
            (key == 'ownerSecondaryPhoneNumber' || key == 'ownerPrimaryPhoneNumber')
        ) {
            state.phoneToValidate = rawValue;
        }

        state[collection][key] = value;
        this.setState(state);
    };

    onAddressPointLocationChange = (value: ICoordinate) => {
        let state = this.state;
        state.addressInfo.addressPointLocation = value;
        this.setState(state);
    };

    onAddressValidationChange = (isValid: boolean) => {
        this.setState({ isAddressValid: isValid } as IState);
    };

    onSelectedOrderAdditions = (id: number) => {
        let selectedOrderAdditions = this.state.selectedOrderAdditions;
        let index = selectedOrderAdditions.indexOf(id);
        if (index >= 0) {
            selectedOrderAdditions.splice(index, 1);
        } else {
            selectedOrderAdditions.push(id);
        }

        this.setState({
            selectedOrderAdditions: selectedOrderAdditions
        } as IState);
    };

    phoneNumberIsValid = (phoneNumber: string): boolean => {
        return phoneRegexp.test(phoneNumber);
    };

    emailIsValid = (email: string): boolean => {
        return emailRegexp.test(email);
    };

    pageIsValid = (page: number) => {
        let state = this.state;

        if (page === 0) {
            return state.selectedBrokerFirm !== null;
        }
        if (page === 1) {
            return state.selectedProduct !== null;
        }
        if (page === 2) {
            let contactInfo = state.contactInfo as ICreateOrderContact;
            let addressInfo = state.addressInfo as ICreateOrderAddress;
            let apartmentObjectType = '1';
            let villaObjectType = '2';
            let objectTypeSpecificInfoIsValid = true;
            let numberOfPlansValid = true;

            if (addressInfo.objectType.toString() === apartmentObjectType) {
                objectTypeSpecificInfoIsValid =
                    addressInfo.objectNumberOfRooms !== '' &&
                    addressInfo.objectNumberOfRooms !== null &&
                    addressInfo.apartmentFloor !== '' &&
                    addressInfo.apartmentFloor !== null;
            } else if (addressInfo.objectType.toString() === villaObjectType) {
                objectTypeSpecificInfoIsValid =
                    addressInfo.objectAreaSquareMeters !== '' &&
                    addressInfo.objectAreaSquareMeters !== null;
            }

            if (this.getSelectedAdditionalProducts().some((p) => p.isMeasured)) {
                numberOfPlansValid = this.state.nrOfPlans > 0 && this.state.nrOfPlans !== null;
            }

            let isValid =
                state.selectedProduct !== null &&
                contactInfo.ownerFirstName !== '' &&
                contactInfo.ownerFirstName !== null &&
                contactInfo.ownerLastName !== '' &&
                contactInfo.ownerLastName !== null &&
                (contactInfo.ownerSecondaryPhoneNumber === '' ||
                    this.phoneNumberIsValid(contactInfo.ownerSecondaryPhoneNumber) ||
                    contactInfo.ownerPrimaryPhoneNumber === '' ||
                    this.phoneNumberIsValid(contactInfo.ownerPrimaryPhoneNumber)) &&
                addressInfo.addressCity !== '' &&
                addressInfo.addressCity !== null &&
                addressInfo.addressLine1 !== '' &&
                addressInfo.addressLine1 !== null &&
                addressInfo.addressPostalNumber !== '' &&
                addressInfo.addressPostalNumber !== null &&
                state.isAddressValid === true &&
                addressInfo.objectType > 0 &&
                objectTypeSpecificInfoIsValid &&
                numberOfPlansValid;

            return isValid;
        }

        if (page === 4) {
            let requiredOwnerMobilePhoneNumber =
                this.state.products
                    .filter((x) => {
                        return x.isAddition;
                    })
                    .filter((x: any) => this.state.selectedOrderAdditions.indexOf(x.id) >= 0)
                    .filter((x: any) => x.requiredOwnerMobilePhoneNumber).length > 0;
            if (requiredOwnerMobilePhoneNumber) {
                return this.phoneNumberIsValid(state.contactInfo.ownerPrimaryPhoneNumber);
            }
            let requiredOwnerEmailAddress =
                this.state.products
                    .filter((x) => {
                        return x.isAddition;
                    })
                    .filter((x: any) => this.state.selectedOrderAdditions.indexOf(x.id) >= 0)
                    .filter((x: any) => x.requiredOwnerEmailAddress).length > 0;
            if (requiredOwnerEmailAddress) {
                return this.emailIsValid(state.contactInfo.ownerEmailAddress);
            }

            return true;
        }

        return false;
    };

    onPhotographerSelected = (calendarItem: ICalendarItem) => {
        this.setState(
            (prevState) =>
                ({
                    calendarItem: calendarItem,
                    activePage: prevState.activePage + 1
                } as IState)
        );
    };

    changePage = (multiplier: number) => {
        this.setState(
            (prevState) =>
                ({
                    activePage: prevState.activePage + multiplier
                } as IState)
        );
    };

    createOrder = () => {
        let calendarItem = this.state.calendarItem;
        let orderProperties: any = assign({}, this.props.orderProperties);

        orderProperties.products = this.state.products;
        orderProperties.address = this.state.addressInfo;
        orderProperties.contact = this.state.contactInfo;
        orderProperties.other = this.state.otherInfo;
        orderProperties.productInfo = {
            selectedProduct: this.state.selectedProduct,
            selectedAdditionalProducts: this.state.selectedAdditionalProducts,
            selectedOrderAdditions: [...this.state.selectedOrderAdditions]
        };
        orderProperties.brokerFirmId = this.state.brokerFirmId;
        orderProperties.brokerAgent = this.state.selectedBrokerAgent;
        orderProperties.numberOfMeasuredPlans = this.state.nrOfPlans;
        orderProperties.pendingOrderId = this.state.pendingOrderId;

        Api.default
            .createOrder(orderProperties, calendarItem, this.state.orderCollectionId)
            .then((createOrderResult: any) => {
                notify.success(Translate('scandphotos/orders/create/toastr/success'));
                this.redirect(createOrderResult.order);
            })
            .catch(() => {
                notify.failure(Translate('scandphotos/orders/create/toastr/error'));
            });
    };

    redirect = (order: any) => {
        if (order.planOrderId && !order.isMeasured) {
            this.props.history.push('/orders/' + order.planOrderId + '/plan');
        } else {
            this.props.history.push('/orders');
        }
    };

    onAgentChanged = (e: any) => {
        this.onAgentSelected(parseInt(e.target.value));
    };

    onAgentSelected = (agentId: number) => {
        let selectedBrokerAgent = this.props.orderProperties.availableBrokerAgents.filter(
            (a: any) => a.id === agentId
        )[0];

        this.setState(
            {
                products: [],
                selectedBrokerAgent: selectedBrokerAgent
            } as IState,
            this.preSelectHeadQuarterFirm
        );
    };

    preSelectHeadQuarterFirm = () => {
        let availableFirms = this.getAvailableBrokerFirms();
        if (availableFirms.length > 0) {
            let brokerFirmId = availableFirms.filter((x: any) => x.isHeadQuarter)[0].id;
            this.onFirmSelected(brokerFirmId);
        }
    };

    getAvailableBrokerFirms = (): IBrokerFirm[] => {
        if (this.state.selectedBrokerAgent) {
            return this.state.selectedBrokerAgent.availableBrokerFirms;
        } else {
            return [];
        }
    };

    onFirmChanged = (e: any) => {
        let brokerFirmId = parseInt(e.target.value);
        this.onFirmSelected(brokerFirmId);
    };

    onFirmSelected = (firmId: number) => {
        let selectedBrokerFirm = this.getAvailableBrokerFirms().filter((a: any) => a.id === firmId);

        this.setState(
            {
                selectedBrokerFirm:
                    selectedBrokerFirm.length > 0 ? selectedBrokerFirm[0] : undefined,
                brokerFirmId: firmId
            } as IState,
            () => this.props.actions.getFirmDetails(firmId)
        );
    };

    getSelectedAdditionalProducts = () => {
        return this.state.products.filter((p) => {
            return (
                this.state.selectedOrderAdditions.indexOf(p.id) >= 0 ||
                this.state.selectedAdditionalProducts.indexOf(p.id) >= 0
            );
        });
    };

    loadPendingOrder = () => {
        let pendingOrder = PendingOrderStore.get();
        let newPendingOrder = true;
        let collectionId = this.state.orderCollectionId;

        this.props.actions
            .newOrder(pendingOrder.pendingOrderId, collectionId, newPendingOrder)
            .then(() => {
                this.preSelectBrokerAgent();
                this.setState({
                    pickupDialogOpen: false,
                    keepPendingOrderLoading: false
                });
                notify.success(Translate('order/create/pickup-dialog/toaster-confirm'));
            })
            .catch((error: any) => {
                handleError(error);
                this.setState({
                    pickupDialogOpen: false,
                    keepPendingOrderLoading: false
                });
            });

        this.setState({ keepPendingOrderLoading: true });
    };

    render() {
        const pendingOrder = PendingOrderStore.get();

        return (
            <div>
                {pendingOrder && (
                    <PickupOrderDialog
                        onCancel={() => {}}
                        isOpen={this.state.pickupDialogOpen}
                        title={Translate('order/create/pickup-dialog/title', {
                            contentprovider: getContentProviderNameFromId(
                                pendingOrder.contentProviderId
                            )
                        })}
                        textContent={
                            <>
                                <p
                                    dangerouslySetInnerHTML={{
                                        __html: Translate('order/create/pickup-dialog/body1', {
                                            contentprovider: getContentProviderNameFromId(
                                                pendingOrder.contentProviderId
                                            ),
                                            address: pendingOrder.address
                                        })
                                    }}
                                ></p>
                                <p>
                                    {Translate('order/create/pickup-dialog/body2', {
                                        contentprovider: getContentProviderNameFromId(
                                            pendingOrder.contentProviderId
                                        )
                                    })}
                                    <br />
                                    <span className="pickup-dialog body3">
                                        {Translate('order/create/pickup-dialog/body3', {
                                            contentprovider: getContentProviderNameFromId(
                                                pendingOrder.contentProviderId
                                            )
                                        })}
                                    </span>
                                </p>
                            </>
                        }
                    >
                        {!this.state.keepPendingOrderLoading && (
                            <>
                                <Button
                                    onClick={() => {
                                        PendingOrderStore.clear();
                                        notify.info(
                                            Translate('order/create/pickup-dialog/toaster-cancel')
                                        );
                                        this.setState({
                                            pickupDialogOpen: false
                                        });
                                    }}
                                >
                                    {Translate('order/create/pickup-dialog/button-cancel')}
                                </Button>
                                <Button
                                    bsStyle="success"
                                    onClick={() => {
                                        this.loadPendingOrder();
                                    }}
                                >
                                    {Translate('order/create/pickup-dialog/button-accept')}
                                </Button>
                            </>
                        )}
                    </PickupOrderDialog>
                )}

                <h1 data-testid="scandphotos-create-order-title">
                    {Translate('scandphotos/orders/create/title/create-order')}
                </h1>
                <Row className="create-order-legend">
                    <Col xs={2} className={this.state.activePage === 0 ? 'active' : ''}>
                        <span>{Translate('scandphotos/orders/create/subtitle/who')}</span>
                    </Col>
                    <Col xs={2} className={this.state.activePage === 1 ? 'active' : ''}>
                        <span>{Translate('scandphotos/orders/create/subtitle/what')}</span>
                    </Col>
                    <Col xs={2} className={this.state.activePage === 2 ? 'active' : ''}>
                        <span>{Translate('scandphotos/orders/create/subtitle/where')}</span>
                    </Col>
                    <Col xs={2} className={this.state.activePage === 3 ? 'active' : ''}>
                        <span>{Translate('scandphotos/orders/create/subtitle/when')}</span>
                    </Col>
                    <Col xs={2} className={this.state.activePage === 4 ? 'active' : ''}>
                        <span>{Translate('scandphotos/orders/create/subtitle/complete')}</span>
                    </Col>
                    <Col xs={2} className={this.state.activePage === 5 ? 'active' : ''}>
                        <span>{Translate('scandphotos/orders/create/subtitle/confirm')}</span>
                    </Col>
                </Row>
                <Row>
                    {this.state.activePage === 0 && (
                        <ScandphotosCreateOrderBrokerAndFirmPage
                            user={this.props.user}
                            selectedBrokerAgentId={
                                this.state.selectedBrokerAgent
                                    ? this.state.selectedBrokerAgent.id
                                    : undefined
                            }
                            onAgentChanged={this.onAgentChanged}
                            onFirmChanged={this.onFirmChanged}
                            availableBrokerAgents={this.props.orderProperties.availableBrokerAgents}
                            getAvailableBrokerFirms={this.getAvailableBrokerFirms}
                        />
                    )}

                    {this.state.activePage === 1 && (
                        <ScandphotosCreateOrderProductsPage
                            products={this.state.products}
                            selectedProduct={this.state.selectedProduct}
                            selectedAdditionalProducts={this.state.selectedAdditionalProducts}
                            onPackageChange={(id) => this.onPackageChange(id)}
                            onPackageAdditionChange={(id) => this.onPackageAdditionChange(id)}
                        />
                    )}

                    {this.state.activePage === 2 && (
                        <ScandphotosCreateOrderContactPage
                            otherInfo={this.state.otherInfo}
                            objectTypes={this.state.objectTypes}
                            contactInfo={this.state.contactInfo}
                            addressInfo={this.state.addressInfo}
                            nrOfPlans={this.state.nrOfPlans}
                            onNrOfPlansChange={(evt) => {
                                this.onNrOfPlansChange(evt);
                            }}
                            objectTypeLockDown={this.state.objectTypeLockDown}
                            onChange={(collection, key, value, rawValue) => {
                                this.onOrderInfoChange(collection, key, value, rawValue);
                            }}
                            onAddressPointLocationChange={this.onAddressPointLocationChange}
                            onAddressValidationChange={this.onAddressValidationChange}
                            enableNumberOfPlans={this.getSelectedAdditionalProducts().some(
                                (p) => p.isMeasured
                            )}
                            phoneToValidate={this.state.phoneToValidate}
                        />
                    )}

                    {this.state.activePage === 3 && (
                        <div>
                            <ScandphotosPhotographerBooking
                                onSelected={(calendarItem) => {
                                    this.onPhotographerSelected(calendarItem);
                                }}
                                orderInfo={{
                                    address: this.state.addressInfo.addressLine1,
                                    postalCode: this.state.addressInfo.addressPostalNumber,
                                    city: this.state.addressInfo.addressCity,
                                    addressPointLocation:
                                        this.state.addressInfo.addressPointLocation,
                                    product: this.state.products.find((x) => {
                                        return x.id === this.state.selectedProduct;
                                    }),
                                    additionalProducts: this.state.products.filter((x) => {
                                        return (
                                            this.state.selectedAdditionalProducts.indexOf(x.id) >= 0
                                        );
                                    }),
                                    brokerFirmRegionId: (this.props.orderProperties as any)
                                        .brokerFirmRegionId,
                                    brokerFirmId: this.state.selectedBrokerFirm.id,
                                    numberOfMeasuredPlans: this.state.nrOfPlans
                                }}
                                buttonLabel={Translate(
                                    'scandphotos/photographerbooking/page/button/book-and-proceed'
                                )}
                            />
                        </div>
                    )}

                    {this.state.activePage === 4 && (
                        <ScandphotosCreateOrderCompletePage
                            onSelectedOrderAdditions={(id: number) => {
                                this.onSelectedOrderAdditions(id);
                            }}
                            orderAdditions={this.state.products.filter((x) => {
                                return x.isAddition;
                            })}
                            selectedOrderAdditions={this.state.selectedOrderAdditions}
                            otherInfo={this.state.otherInfo}
                            contactInfo={this.state.contactInfo}
                            onChange={(collection, key, value) => {
                                this.onOrderInfoChange(collection, key, value);
                            }}
                            existingPlanOrderId={this.props.orderProperties.existingPlanOrderId}
                        />
                    )}

                    {this.state.activePage === 5 && (
                        <ScandphotosCreateOrderConfirmationPage
                            contactInfo={this.state.contactInfo}
                            addressInfo={this.state.addressInfo}
                            objectTypes={this.state.objectTypes}
                            nrOfPlans={this.state.nrOfPlans}
                            additionalProducts={this.getSelectedAdditionalProducts()}
                            selectedProduct={this.state.products.find((p) => {
                                return p.id === this.state.selectedProduct;
                            })}
                            currency={this.state.selectedBrokerFirm.currency}
                        />
                    )}
                </Row>
                <Row>
                    <Col xs={12}>
                        {this.state.activePage > 0 && (
                            <Button
                                bsStyle="info"
                                bsSize="lg"
                                className="pull-left"
                                onClick={() => {
                                    this.changePage(-1);
                                }}
                            >
                                {Translate('scandphotos/orders/create/button/previous')}
                            </Button>
                        )}
                        {this.pageIsValid(this.state.activePage) && this.state.activePage < 5 && (
                            <Button
                                data-testid="scandphotos-next"
                                bsStyle="info"
                                bsSize="lg"
                                className="pull-right"
                                onClick={() => {
                                    this.changePage(1);
                                }}
                            >
                                {Translate('scandphotos/orders/create/button/next')}
                            </Button>
                        )}
                        {this.state.activePage === 5 && (
                            <Button
                                data-testid="scandphotos-create-order-submit"
                                bsStyle="primary"
                                bsSize="lg"
                                className="pull-right"
                                onClick={() => {
                                    this.createOrder();
                                }}
                            >
                                {Translate('scandphotos/orders/create/button/create-order')}
                            </Button>
                        )}
                    </Col>
                </Row>
            </div>
        );
    }
}

function mapStateToProps(state: any) {
    let orderProperties: ICreateOrder = getOrderProperties(state);

    return {
        orderProperties,
        user: getUser(state),
        newProducts: getNewProducts(state)
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            newOrder: (
                pendingOrderId?: string,
                orderCollectionId?: number,
                newPendingOrder?: boolean
            ) => dispatch(Actions.newOrder(pendingOrderId, orderCollectionId, newPendingOrder)),
            getFirmDetails: (firmId: number) => dispatch(actions.getFirmDetails(firmId))
        } as IActions
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ScandphotosCreateOrderPage);
